import { queryString } from '@/utils/queryString'
import { clipboardCopy } from '@/utils/copy'

import ICON_GMAIL from 'common/icon-gmail.png'
import ICON_TWITTER from 'common/icon-twitter.svg'
import ICON_FACEBOOK from 'common/icon-facebook.svg'
import ICON_LINE from 'common/icon-line.svg'
import ICON_WHATSAPP from 'common/icon-whatsapp.svg'
export interface SOCIAL_BADGE {
  link: string
  icon: string
  title: string
}

export const LINE_SHARE_URL = 'https://social-plugins.line.me/lineit/share'
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/dialog/share'
export const FACEBOOK_APP_ID = '895685018881538'
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet'
export const TWITTER_SOCIAL_SHARE_MESSAGE = '#CUSTAInsight'
export const TWITTER_SHARE_MESSAGE = 'Made with #CUSTAInsight!'
export const TWITTER_HASHTAGS = ['CUSTA', 'Insight']
export const WHATSAPP_SHARE_URL = 'https://wa.me/'
export const WHATSAPP_CUSTA_CS = 'https://wa.me/60177112285'


export const requestSampleMsg = (shareUrl: string ): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    text: `${encodeURIComponent('Hi CUSTA Team,')}%0A%0A${encodeURIComponent('I want to request sample for: ')}${encodeURIComponent(shareUrl)}%0A%0A${encodeURIComponent('Thanks')}`
  })

  return `${WHATSAPP_CUSTA_CS}?${query}`
}

export const requestDesignerMsg = (shareUrl: string ): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    text: `${encodeURIComponent('Hi CUSTA Team,')}%0A%0A${encodeURIComponent('I need designer service for the following product: ')}${encodeURIComponent(shareUrl)}%0A%0A${encodeURIComponent('Thanks')}`
  })

  return `${WHATSAPP_CUSTA_CS}?${query}`
}

export const twitterUrl = (shareUrl: string, shareMessage?: string): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    text: encodeURIComponent(
      `${TWITTER_SHARE_MESSAGE}\n${shareMessage}`
    ),
    url: encodeURIComponent(shareUrl),
    hashtags: TWITTER_HASHTAGS.join(',')
  })
  return `${TWITTER_SHARE_URL}?${query}`
}

const emailUrl = (shareUrl: string, shareMessage?: string): string => {
  if (!shareUrl) return ''
  const formatEmailSubject = 'Check out this product from CUSTA'
  const formatEmailBody = `Check out this product from CUSTA!\n${shareMessage}\n${shareUrl}`
  return `mailto:?subject=${formatEmailSubject}&body=${encodeURIComponent(formatEmailBody)}`
}

const whatsappUrl = (shareUrl: string, shareMessage?: string ): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    text: `${encodeURIComponent(shareMessage ?? '')}\n${encodeURIComponent(shareUrl)}`
  })
  return `${WHATSAPP_SHARE_URL}?${query}`
}

const facebookUrl = (shareUrl: string): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    app_id: FACEBOOK_APP_ID,
    display: 'popup',
    href: encodeURIComponent(shareUrl),
    redirect_uri: encodeURIComponent(shareUrl)
  })
  return `${FACEBOOK_SHARE_URL}?${query}`
}

const lineUrl = (shareUrl: string): string => {
  if (!shareUrl) return ''
  const query = queryString.toString({
    url: encodeURIComponent(shareUrl)
  })
  return `${LINE_SHARE_URL}?${query}`
}

export const SOCIAL_BADGES = (shareUrl: string, shareMessage?: string): Array<SOCIAL_BADGE> => {
  return [
    {
      link: whatsappUrl(shareUrl, shareMessage),
      icon: ICON_WHATSAPP,
      title: 'WhatsApp'
    },{
      link: emailUrl(shareUrl, shareMessage),
      icon: ICON_GMAIL,
      title: 'Email'
    },
    {
      link: facebookUrl(shareUrl),
      icon: ICON_FACEBOOK,
      title: 'Facebook'
    },{
      link: lineUrl(shareUrl),
      icon: ICON_LINE,
      title: 'Line'
    },
    {
      link: twitterUrl(shareUrl, shareMessage),
      icon: ICON_TWITTER,
      title: 'Twitter'
    }
  ]
}

export const LINK_COPY = (shareUrl: string) => {
  if (!shareUrl) return
  clipboardCopy(shareUrl)
  alert('Link copied!')
}
